import { Button } from "@/components/ui/button";
import { Menu, LogOut } from "lucide-react";

interface AdminTopbarProps {
  onMenuClick: () => void;
  onLogout: () => void;
}

export default function AdminTopbar({ onMenuClick, onLogout }: AdminTopbarProps) {
  return (
    <header className="border-b bg-background px-4 sm:px-6 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden mr-2 z-50"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('Menu button clicked');
              onMenuClick();
            }}
          >
            <Menu className="h-6 w-6" />
            <span className="sr-only">Open sidebar</span>
          </Button>
          <h1 className="text-xl font-bold">RSSYes Admin</h1>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm">
            Settings
          </Button>
          <Button variant="outline" size="sm">
            Profile
          </Button>
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onLogout}
            className="flex items-center gap-1 text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <LogOut className="h-4 w-4" />
            <span>Logout</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
